import { render } from "./InitialNavbar.vue?vue&type=template&id=b10155bc&scoped=true"
import script from "./InitialNavbar.vue?vue&type=script&lang=js"
export * from "./InitialNavbar.vue?vue&type=script&lang=js"

import "./InitialNavbar.vue?vue&type=style&index=0&id=b10155bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b10155bc"]])

export default __exports__